<script>
/**
 * ****************************************************************************
 * @description     :   Pagination Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************

/**
 * Import template
 */
import template from './template.html';
import style from './style.scss';

/**
 * Define content of paginator component
 */
var AnsPagination = {
    template: template,
    style: style,
    props: {
        customClass: String,
        customSelectClass: {
            type: [String, Object],
            default: ''
        },
        isDisabled: Boolean,
        pageSize: {
            type: [String, Number],
            default: 20
        },
        row_start: {
            type: [Number],
            default: 1
        },
        row_end: {
            type: [Number],
            default: 10
        },
        totalRows: {
            type: [String, Number],
            default: 0
        },
        pageNo: {
            type: [Number],
            default: 1
        },
        optionPageSize: {
            type: Array,
            default: () => {
                return [
                    {
                        code: 10,
                        name: '10件'
                    },
                    {
                        code: 50,
                        name: '50件'
                    },
                    {
                        code: 100,
                        name: '100件'
                    }
                ];
            }
        },
        optionPageSize2: {
            type: Array,
            default: () => {
                return [
                    {
                        code: 0,
                        name: '全件'
                    },
                    {
                        code: 10,
                        name: '10件'
                    },
                    {
                        code: 50,
                        name: '50件'
                    },
                    {
                        code: 100,
                        name: '100件'
                    }
                ];
            }
        },
        optionPageSize3: {
            type: Array,
            default: () => {
                return [
                    {
                        code: 50,
                        name: '50件'
                    },
                    {
                        code: 100,
                        name: '100件'
                    }
                ];
            }
        },
        optionsStyle: {
            type: Object,
            default() {
                return { pageSize: { wrapClass: '' } };
            }
        },
        pageCollapse: {
            type: Boolean,
            default: false
        },
        pageAll: {
            type: Boolean,
            default: false
        },
        pageSizeUp50: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.reCalculateEndRow();
    },
    data() {
        return {
            currentPage: this.pageNo,
            perPage: this.pageAll ? 0 : this.pageSizeUp50 ? 50 : this.pageSize,
            internalRowStart: this.row_start,
            internalRowEnd: this.row_end
        };
    },
    mounted() {
        this.patchTabindex();
    },
    updated() {
        this.patchTabindex();
    },
    watch: {
        perPage(val) {
            if (val) {
                this.currentPage = 1;
                this.$emit('changePage', {
                    currentPage: this.currentPage,
                    perPage: parseInt(this.perPage)
                });
                this.internalRowStart = 1;
                this.internalRowEnd = val == 0 ? this.totalRows : val;
                this.reCalculateEndRow();
            }
        },
        pageNo(val) {
            if (val) {
                this.currentPage = this.pageNo;
            }
        },
        currentPage(val) {
            if (val) {
                this.internalRowStart = (val - 1) * this.perPage + 1;
                this.internalRowEnd = val * (this.perPage == 0 ? this.totalRows : this.perPage);
                if (this.internalRowEnd > this.totalRows) {
                    this.internalRowEnd = this.totalRows;
                }
                this.$emit('changePage', {
                    currentPage: this.currentPage,
                    perPage: parseInt(this.perPage)
                });
            }
        },
        totalRows(val) {
            if (val) {
                this.reCalculateEndRow();
            }
        }
    },
    computed: {
        selectClass() {
            const baseClasses = {
                'item-component': false
            };

            if (typeof this.customSelectClass === 'object' && this.customSelectClass !== null) {
                return { ...baseClasses, ...this.customSelectClass };
            } else if (typeof this.customSelectClass === 'string' && this.customSelectClass) {
                return { ...baseClasses, [this.customSelectClass]: true };
            }

            return baseClasses;
        }
    },
    methods: {
        reCalculateEndRow() {
            if (parseInt(this.totalRows) < parseInt(this.perPage) || this.perPage == 0) {
                this.internalRowEnd = this.totalRows;
            } else {
                this.internalRowEnd = this.perPage;
            }
        },
        patchTabindex() {
            this.$nextTick(() => {
                this.$el.querySelectorAll('.pagination .page-link').forEach((btn) => {
                    btn.setAttribute('tabindex', '-1');
                });
            });
        }
    }
};
export default AnsPagination;
</script>
